<template>
  <LinkWrapper
    class="h-56 shadow-md xs:w-64 xs:space-y-4 md-space-y-0 md:w-auto"
    :link-url="fields.linkUrl"
    :is-external-link="fields.isExternalLink"
  >
    <div
      class="box-border relative w-full h-full p-8 text-xs rounded lg:p-10"
      :class="setCmsTemplateClasses(fields.template || '', 'random-banner')"
    >
      <ContentfulImage
        v-if="fields.contentImage"
        :entry="fields.contentImage"
        :width="140"
        :height="140"
        fit="fill"
        class="absolute bottom-0 right-0 w-16 rounded z-1 xl:w-32"
      />
      <div>
        <span class="text">{{ fields.preTitle }}</span>
        <h3 class="mt-2 mb-4 text-sm font-bold title lg:text-md xl:text-xl">{{ fields.title }}</h3>
        <p class="text">{{ fields.text }}</p>
      </div>
      <CButton
        v-if="fields.buttonText"
        class="absolute px-8 py-0 text-xs font-bold bottom-4 z-1"
        variant="secondary"
        size="small"
      >
        {{ fields.buttonText }}
      </CButton>
    </div>
  </LinkWrapper>
</template>

<script setup lang="ts">
import { setCmsTemplateClasses } from '@/config/cms';
import type { ContentfulImageType } from '@/types/contentful';
type Props = {
  content?: {
    fields: {
      linkUrl?: string;
      isExternalLink?: boolean;
      contentImage?: ContentfulImageType;
      preTitle?: string;
      title?: string;
      text?: string;
      buttonText?: string;
      template?: string;
    };
  };
};
const props = withDefaults(defineProps<Props>(), {
  content: () => ({ fields: {} }),
});

const fields = computed(() => props.content.fields);
</script>

<script lang="ts">
export default defineComponent({
  name: 'RandomBanner',
});
</script>
